const $inject = ['$rootScope', '$scope', 'dataService'];

const lbaSearchByCtrl = function ($rootScope, $scope, dataService) {
  const vm = this;
  vm.search = search;
  vm.searching = false;
  dataService.refreshDataOnLoad = true;

  vm.addFilter = addFilter;
  vm.removeFilter = removeFilter;
  vm.cancelSearch = cancelSearch;

  const initialSearch = [{
    key: vm.settings.targetChoices[0],
    value: ''
  }]

  function removeFilter(index) {
    vm.searchFilters = vm.searchFilters.filter((item, i) => i != index);
  }

  function addFilter() {
    vm.searchFilters.push({
      key: vm.settings.targetChoices[0],
      value: ''
    })
  }

  function cancelSearch() {    
    dataService.cancelSearch();
    vm.searchResults = [];
    vm.searching = false;
  }

  const prevSearch = JSON.parse(sessionStorage.getItem(`searchByData:${vm.settings.displayName}`));
  if (prevSearch) {
    vm.searchResults = prevSearch.searchResults || [];
    vm.exactMatches = prevSearch.exactMatches;
    vm.searchFilters = prevSearch.searchFilters || initialSearch;
    vm.includeDeleted = prevSearch.includeDeleted
  } else {
    vm.searchResults = [];
    vm.exactMatches = false;
    vm.searchFilters = initialSearch;
  }

  vm.activeFilters = [];

  $scope.$watch('vm.searchFilters', function (newData, oldData) {
    if (newData) {
      vm.activeFilters = newData.filter(item => item.key && item.value);
    }
  }, true);
  
  function search() {
    if (vm.activeFilters.length === 0) return;

    vm.searching = true;
    dataService.refreshDataOnLoad = true;

    dataService.search({
      endpoint: vm.settings.endpoint,
      filters: vm.activeFilters,
      expression: vm.exactMatches ? 'exact' : 'contains',
      includeDeleted: vm.includeDeleted
    }).then(data => {
      vm.searching = false;
      vm.searchResults = data;

      try {
        sessionStorage.setItem(`searchByData:${vm.settings.displayName}`, JSON.stringify({ searchResults: vm.searchResults, searchFilters: vm.searchFilters, exactMatches: vm.exactMatches, includeDeleted: vm.includeDeleted}));
      } catch(err) {
        console.warn(err);
        sessionStorage.removeItem(`searchByData:${vm.settings.displayName}`);
      }

    }).catch(err => {
      console.warn('err :>> ', err);
      $rootScope.$broadcast('lbaLoader:loaderState', {state: 'error'});
      vm.searching = false;
      vm.searchResults = [];
      sessionStorage.removeItem(`searchByData:${vm.settings.displayName}`);
    });
  }   
};

lbaSearchByCtrl.$inject = $inject;

export default lbaSearchByCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaSearchBy/lbaSearchByCtrl.js